export enum ChannelOptions {
	None = 0,
	LeftYAxis = 1,
	Hidden = 2,
	HiddenGraph = 4,
	VeryHidden = 8
}
